// import React, { useState, useMemo, useEffect } from "react";
// import { MdEdit, MdDelete } from "react-icons/md";
// import Table from "../Common/Table/main";
// import SearchBar from "../Common/SearchBar/main";
// import Pagination from "../Pagination/main";
// import dayjs, { Dayjs } from "dayjs";
// import { TriggerStore } from "../../Store";
// import { Popup } from "../Common/Popup/main";
// import { DatePicker, DatePickerProps } from "antd";
// import ExpenseForm from "../Popups/expenses";
// import DeletePopup from "../Popups/deletePopup";
// import { useExpenses } from "../../hook/useExpenses";
// import {
//   ExpenseApiResponse,
//   ExpenseResponseDTO as Expense,
//   CreateExpenseRequest,
//   ExpenseFilterDTO,
// } from "../../hook/types/expenses";
// import toast from "react-hot-toast";
// import { User } from "../../hook/types/users";
// import { useProperties } from "../../hook/useProperties";

// interface ExpenseInfo {
//   propertyName: string;
//   tenantName: string;
//   expenseId: string;
//   expenseType: string;
//   amount: number;
//   date: string;
//   comments: string;
// }

// const initialData: ExpenseInfo = {
//   propertyName: "",
//   expenseId: "",
//   tenantName: "",
//   expenseType: "",
//   amount: 0,
//   date: "",
//   comments: "",
// };

// const EditAndDeleteButton: React.FC<{
//   onEdit: () => void;
//   onDelete: () => void;
// }> = ({ onEdit, onDelete }) => {
//   return (
//     <div className="flex space-x-2 justify-center">
//       <button className="btn btn-secondary" onClick={onEdit}>
//         <MdEdit className="h-5 w-5 hover:text-primary" />
//       </button>
//       <button className="btn btn-danger" onClick={onDelete}>
//         <MdDelete className="h-5 w-5 hover:text-red-500" />
//       </button>
//     </div>
//   );
// };

// const ExpenseCard: React.FC = () => {
//   const { Expenses, addExpense, deleteExpense, updateExpense, queryClient } =
//     useExpenses();

//   const uid = localStorage.getItem("R_M_uid");
//   const userData = queryClient.getQueryData(["users", uid]) as User;
//   const data = queryClient.getQueryData(["expenses"]) as ExpenseApiResponse;

//   const { sidebarAction, sidebartrigger } = TriggerStore((state) => state);
//   const [activeAddressId, setActiveAddressId] = useState<number | undefined>(
//     undefined
//   );
//   const [DeletPopup, setDeletPopup] = useState(false);
//   const [activeId, setActiveId] = useState("");
//   const [placement, SetPlacement] =
//     useState<DatePickerProps["placement"]>("topLeft");
//   const [openPopup, setOpenPopup] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [dateFilter, setDateFilter] = useState<{
//     startDate: string;
//     endDate: string;
//   }>({
//     // startDate: dayjs(`${dayjs().year()}-01-01`).format("YYYY-MM-DD"),
//     // endDate: dayjs(`${dayjs().year()}-12-31`).format("YYYY-MM-DD"),
//     startDate: dayjs().startOf('month').format("YYYY-MM-DD"),
// endDate: dayjs().endOf('month').format("YYYY-MM-DD"),
//   });
//   const [addExpenseStatus, setAddExpense] = useState(false);
//   const [selectedExpense, setSelectedExpense] =
//     useState<ExpenseInfo>(initialData);

//   const [currentPage, setCurrentPage] = useState(0);
//   const [itemsPerPage, setItemsPerPage] = useState(25);

//   const { Property } = useProperties();
//   const PropertiesData = Property({
//     active: true,
//     delete: false,
//     page: 0,
//     size: 10,
//   }) as any;

//   const [propertyId, setPropertyId] = useState<number | null>(null);
//   const expenses = Expenses({
//     fromDate: dateFilter.startDate,
//     toDate: dateFilter.endDate,
//     page: currentPage,
//     size: itemsPerPage,
//     propertyName: searchQuery,
//   });

//   useEffect(() => {
//     if (expenses.isSuccess) {
//     //  console.log("Raw Expenses Data from API:", expenses.data?.data?.content);
//     }
//   }, [expenses.isSuccess, expenses.data]);

//   const totalItems = expenses.data?.data?.totalElements || 0;
//   const currentItems = expenses.data?.data?.content || [];

//   const columns = [
//     { key: "propertyName", title: "Property Name", type: "text" },
//     { key: "tenantName", title: "Tenant Name", type: "text" },
//     { key: "expenseType", title: "Expense Type", type: "text" },
//     { key: "amount", title: "Expense Amount", type: "number" },
//     { key: "date", title: "Date", type: "date" },
//     { key: "actions", title: "Actions", type: "component"},
//   ];

// const handleEdit = (expense: ExpenseInfo) => {
//   setSelectedExpense(expense);
  
//   // Find the property in your PropertiesData to get the address ID
//   const allProperties = [
//     ...(PropertiesData.data?.data?.COMMERCIAL || []),
//     ...(PropertiesData.data?.data?.RESIDENTIAL || []),
//   ];
  
//   const property = allProperties.find(
//     (prop: any) => prop.propertyName === expense.propertyName
//   );
  
//   if (property) {
//     setActiveAddressId(property.id);
//   } else {
//     // If property not found, try to get it from the expense data if available
//     const expenseItem = currentItems.find((item: Expense) => 
//       item.propertyName === expense.propertyName
//     );
//     if (expenseItem?.propertyAddress?.id) {
//       setActiveAddressId(expenseItem.propertyAddress.id);
//     }
//   }
  
//   setOpenPopup(true);
// };

//   const handleDelete = () => {
//     if (!activeId) return;
//     deleteExpense.mutateAsync(activeId).then(() => {
//       setDeletPopup(false);
//     });
//   };

//  const handleSubmit = async (formData: Partial<ExpenseInfo>) => {
//   try {
//     if (addExpenseStatus) {
//       // ADD EXPENSE LOGIC (this part is working fine)
//       try {
//         const allProperties = [
//           ...(PropertiesData.data?.data?.COMMERCIAL || []),
//           ...(PropertiesData.data?.data?.RESIDENTIAL || []),
//         ];
//         const selectedProperty = allProperties.find(
//           (prop: any) => prop.id === activeAddressId
//         );

//         if (!selectedProperty) {
//           console.log(formData.propertyName)
//           console.log(selectedExpense.propertyName)
//           toast.error("Please select a valid property.");
//           return;
//         }
//         if (activeAddressId === undefined || activeAddressId === null) {
//           toast.error("Property Address ID is missing. Please select a property.");
//           return;
//         }

//         const expenseData: CreateExpenseRequest = {
//           propertyName: selectedProperty.propertyName,
//           tenantName: selectedProperty.tenantName || "",
//           expenseType: formData.expenseType || "",
//           amount: parseInt(formData.amount as unknown as string),
//           date: formData.date || "",
//           comments: formData.comments || "",
//           propertyAddress: activeAddressId,
//         };

//         await addExpense.mutateAsync(expenseData).then(() => {
//           setAddExpense(false);
//           setOpenPopup(false);
//         });
//       } catch (error: any) {
//         if (error?.response?.data?.message) {
//           toast.error(error.response.data.message);
//         } else {
//           toast.error("Something went wrong while adding expense!");
//         }
//       }
//     } else {
//       // UPDATE EXPENSE LOGIC (FIXED)
//       try {
//         // Ensure activeAddressId is set - this is the key fix
        
//         if (!activeAddressId) {
//           toast.error("Property Address ID is missing. Please select a property.");
//           return;
//         }

//         // Get the selected property details if we need to update property-related fields
//         const allProperties = [
//           ...(PropertiesData.data?.data?.COMMERCIAL || []),
//           ...(PropertiesData.data?.data?.RESIDENTIAL || []),
//         ];
        
//         const selectedProperty = allProperties.find(
//           (prop: any) => prop.id === activeAddressId
//         );

//         // If property name changed, we need to validate the selected property
//         if (formData.propertyName !== selectedExpense.propertyName && !selectedProperty) {
//           // console.log(formData.propertyName)
//           // console.log(selectedExpense.propertyName)
//           toast.error("Please select a valid property.");
//           return;
//         }

//         const updateData: CreateExpenseRequest = {
//           propertyName: formData.propertyName || selectedExpense.propertyName,
//           tenantName: formData.tenantName || selectedExpense.tenantName,
//           expenseType: formData.expenseType || selectedExpense.expenseType,
//           amount: parseInt(formData.amount as unknown as string) || selectedExpense.amount,
//           date: formData.date || selectedExpense.date,
//           comments: formData.comments || selectedExpense.comments,
//           propertyAddress: activeAddressId, // This must not be null undefined
//         };

//         await updateExpense
//           .mutateAsync({
//             id: activeId,
//             updatedExpense: updateData,
//           })
//           .then(() => {
//             setAddExpense(false);
//             setOpenPopup(false);
//           });
//       } catch (error: any) {
//         if (error?.response?.data?.message) {
//           toast.error(error.response.data.message);
//         } else {
//           toast.error("Something went wrong while updating expense!");
//         }
//       }
//     }

//     setAddExpense(false);
//   } catch (error) {
//     console.error("Error occurred during mutation:", error);
//   }
// };

//   const onDateRangeChange = (dateRange: Dayjs[] | null) => {
//     if (dateRange && dateRange[0] && dateRange[1]) {
//       setDateFilter({
//         startDate: dateRange[0].format("YYYY-MM-DD"),
//         endDate: dateRange[1].format("YYYY-MM-DD"),
//       });
//     } else {
//       setDateFilter({
//         startDate: "",
//         endDate: "",
//       });
//     }
//   };

//   const handleCancel = () => {
//     setOpenPopup(false);
//   };

//   const { RangePicker } = DatePicker;

//   useEffect(() => {
//     if (!PropertiesData.isLoading && PropertiesData.data) {
//     //  console.log("PropertiesData:", PropertiesData);
//     } else if (PropertiesData.isError) {
//       console.error("Error fetching properties:", PropertiesData.error);
//     }
//   }, [
//     PropertiesData.isLoading,
//     PropertiesData.data,
//     PropertiesData.isError,
//     PropertiesData.error,
//   ]);

//   return (
//     <div className=" border flex w-full flex-col">
//       {/* Header */}
//       <header className="sticky top-0 bg-white  shadow z-10">
//         <h1 className="text-2xl text-start font-bold px-5 py-2">Expenses</h1>
//         <div className="py-4 px-5 flex flex-col w-full items-center justify-between ">
//           <div className="flex flex-col sm:flex-row w-full items-center justify-between gap-4">
//             <RangePicker
//               id={"dateDuration"}
//               size="large"
//               className="lg:w-fullY xl:w-auto "
//               placeholder={["start-date", "end-date"]}
//               popupClassName="custom-range-picker-dropdown "
//               onChange={(dateRange) => {
//                 onDateRangeChange(dateRange as Dayjs[]);
//               }}
//               value={
//                 dateFilter.startDate && dateFilter.endDate
//                   ? [dayjs(dateFilter.startDate), dayjs(dateFilter.endDate)]
//                   : null
//               }
//             />

//             <div className="w-full sm:w-auto">
//               <SearchBar
//                 suggestionInputEnable={{
//                   setActiveValue: (value: string) => {
//                     setSearchQuery(value);
//                   },
//                   activeValue: searchQuery,
//                   enable: true,
//                   loading: PropertiesData.isLoading,
//                   onSuggestionSelect: (index: number) => {
//                     const allProperties = [
//                       ...(PropertiesData.data?.data?.COMMERCIAL || []),
//                       ...(PropertiesData.data?.data?.RESIDENTIAL || []),
//                     ];
//                     if (allProperties[index]) {
//                       setPropertyId(allProperties[index]?.id);
//                       setSearchQuery(allProperties[index]?.propertyName);
//                     }
//                   },
//                   suggestions: PropertiesData.isLoading
//                     ? []
//                     : [
//                         ...(PropertiesData.data?.data?.COMMERCIAL || []).map(
//                           (item: any) => item.propertyName
//                         ),
//                         ...(PropertiesData.data?.data?.RESIDENTIAL || []).map(
//                           (item: any) => item.propertyName
//                         ),
//                       ].flat() || [],
//                 }}
//                 // onClear={() => {
//                 //   setSearchQuery("");
//                 //   setDateFilter({
//                 //     startDate: dayjs(`${dayjs().year()}-01-01`).format(
//                 //       "YYYY-MM-DD"
//                 //     ),
//                 //     endDate: dayjs(`${dayjs().year()}-12-31`).format(
//                 //       "YYYY-MM-DD"
//                 //     ),
//                 //   });
//                 //   setPropertyId(null);
//                 // }}
//                 onClear={() => {
//   setSearchQuery("");
//   setDateFilter({
//     startDate: dayjs().startOf('month').format("YYYY-MM-DD"),
//     endDate: dayjs().endOf('month').format("YYYY-MM-DD"),
//   });
// }}
//                 onSearch={(query) => setSearchQuery(query)}
//               />
//             </div>
//             <button
//               className="bg-primary text-white flex gap-1 justify-center  hover:bg-secondary rounded-lg px-4 py-2 text-sm w-full sm:w-auto"
//               onClick={() => {
//                 setSelectedExpense(initialData);
//                 setAddExpense(true);
//                 setOpenPopup(true);
//               }}
//             >
//               Add{" "}
//               <span className="lg:hidden sm:block md:block   xl:block">
//                 New
//               </span>
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* Scrollable Table */}
//       <div className="min-w-full h-full mb-16 md:mb-16 xl:mb-0  overflow-x-auto">
//         <Table
//           columns={columns as any}
//           loading={expenses.isLoading}
//           data={
//             expenses?.data?.data?.content?.map((item: Expense) => ({
//               propertyName: item.propertyName,
//               tenantName: item.tenantName || "",
//               expenseType: item.expenseType,
//               amount: item.amount,
//               date: item.date,
//               comments: item.comments || "",
//               actions: (
//                 <EditAndDeleteButton
//                   onDelete={() => {
//                     setDeletPopup(true);
//                     setActiveId(String(item.id));
//                   }}
//                   onEdit={() => {
//                     setActiveId(String(item.id));
//                     setActiveAddressId(item.propertyAddress?.id);
//                     handleEdit({
//                       propertyName: item.propertyName,
//                       tenantName: item.tenantName || "",
//                       expenseType: item.expenseType,
//                       amount: item.amount,
//                       date: item.date,
//                       comments: item.comments || "",
//                       expenseId: String(item.id),
//                     });
//                   }}
//                 />
//               ),
//             })) || []
//           }
//         />
//       </div>

//       {openPopup && (
//         <Popup
//           closeButton={true}
//           children={
//             <ExpenseForm
//               setActiveAddressId={setActiveAddressId}
//                activeAddressId={activeAddressId} 
//               isLoading={addExpense.isPending || updateExpense.isPending}
//               initialData={selectedExpense}
//               onSubmit={handleSubmit}
//               onCancel={handleCancel}
//               isOpen={openPopup}
//               id={selectedExpense?.expenseId}
//             />
//           }
//           onClose={() => setOpenPopup(false)}
//         />
//       )}
//       {DeletPopup ? (
//         <Popup
//           children={
//             <DeletePopup
//               isLoading={deleteExpense.isPending}
//               isOpen={DeletPopup}
//               onClose={() => setDeletPopup(false)}
//               onDelete={handleDelete}
//             />
//           }
//           onClose={() => setDeletPopup(false)}
//         />
//       ) : null}

//       {/* Pagination */}
//       <footer
//         className={`xl:sticky md:fixed  fixed sm:fixed lg:fixed lg:w-full bottom-0 bg-blue-50 shadow z-10 transition-width duration-300 ${
//           sidebarAction ? "w-[calc(100%)]" : "w-full"
//         }`}
//       >
//         <div className="flex justify-center space-x-2">
//           <Pagination
//             data={currentItems}
//             ExportFunction={true}
//             currentPage={currentPage}
//             itemsPerPage={itemsPerPage}
//             totalItems={totalItems as any}
//             onPageChange={setCurrentPage}
//             onPageSizeChange={setItemsPerPage}
//             fileName="Expenses" 
//           />
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default ExpenseCard;


import React, { useState, useMemo, useEffect } from "react";
import { MdEdit, MdDelete } from "react-icons/md";
import Table from "../Common/Table/main";
import SearchBar from "../Common/SearchBar/main";
import Pagination from "../Pagination/main";
import dayjs, { Dayjs } from "dayjs";
import { TriggerStore } from "../../Store";
import { Popup } from "../Common/Popup/main";
import { DatePicker, DatePickerProps } from "antd";
import ExpenseForm from "../Popups/expenses";
import DeletePopup from "../Popups/deletePopup";
import { useExpenses } from "../../hook/useExpenses";
import {
  ExpenseApiResponse,
  ExpenseResponseDTO as Expense,
  CreateExpenseRequest,
  ExpenseFilterDTO,
} from "../../hook/types/expenses";
import toast from "react-hot-toast";
import { User } from "../../hook/types/users";
import { useProperties } from "../../hook/useProperties";

interface ExpenseInfo {
  propertyName: string;
  tenantName: string;
  expenseId: string;
  expenseType: string;
  amount: number;
  date: string;
  comments: string;
}

const initialData: ExpenseInfo = {
  propertyName: "",
  expenseId: "",
  tenantName: "",
  expenseType: "",
  amount: 0,
  date: "",
  comments: "",
};

const EditAndDeleteButton: React.FC<{
  onEdit: () => void;
  onDelete: () => void;
}> = ({ onEdit, onDelete }) => {
  return (
    <div className="flex space-x-2 justify-center">
      <button className="btn btn-secondary" onClick={onEdit}>
        <MdEdit className="h-5 w-5 hover:text-primary" />
      </button>
      <button className="btn btn-danger" onClick={onDelete}>
        <MdDelete className="h-5 w-5 hover:text-red-500" />
      </button>
    </div>
  );
};

const ExpenseCard: React.FC = () => {
  const { Expenses, addExpense, deleteExpense, updateExpense, queryClient } =
    useExpenses();

  const uid = localStorage.getItem("R_M_uid");
  const userData = queryClient.getQueryData(["users", uid]) as User;
  const data = queryClient.getQueryData(["expenses"]) as ExpenseApiResponse;

  const { sidebarAction, sidebartrigger } = TriggerStore((state) => state);
  const [activeAddressId, setActiveAddressId] = useState<number | undefined>(
    undefined
  );
  const [DeletPopup, setDeletPopup] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [placement, SetPlacement] =
    useState<DatePickerProps["placement"]>("topLeft");
  const [openPopup, setOpenPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [dateFilter, setDateFilter] = useState<{
    startDate: string;
    endDate: string;
  }>({
    startDate: dayjs().startOf('month').format("YYYY-MM-DD"),
    endDate: dayjs().endOf('month').format("YYYY-MM-DD"),
  });
  const [addExpenseStatus, setAddExpense] = useState(false);
  const [selectedExpense, setSelectedExpense] =
    useState<ExpenseInfo>(initialData);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const { Property } = useProperties();
  const PropertiesData = Property({
    active: true,
    delete: false,
    page: 0,
    size: 1000,
  }) as any;

  const [propertyId, setPropertyId] = useState<number | null>(null);
  
  // Get all expenses for client-side filtering
  const expenses = Expenses({
    fromDate: "", // Get all data for client-side filtering
    toDate: "",
    page: 0,
    size: 10000,
    propertyName: "",
  });

  // Filter expenses based on search query and date range
  const filteredExpenses = useMemo(() => {
    if (!expenses.data?.data?.content) return [];

    return expenses.data.data.content.filter((expense) => {
      const matchesSearch = expense.propertyName
        .toLowerCase()
        .includes(searchQuery.toLowerCase());

      const expenseDate = new Date(expense.date);
      const startDate = new Date(dateFilter.startDate);
      const endDate = new Date(dateFilter.endDate);
      endDate.setHours(23, 59, 59, 999); // Include the entire end date

      const withinDateRange =
        (isNaN(startDate.getTime()) || expenseDate >= startDate) &&
        (isNaN(endDate.getTime()) || expenseDate <= endDate);

      return matchesSearch && withinDateRange;
    });
  }, [expenses.data, searchQuery, dateFilter]);

  // Calculate pagination values
  const totalItems = filteredExpenses.length;
  const indexOfFirstItem = currentPage * itemsPerPage;
  const indexOfLastItem = Math.min(
    indexOfFirstItem + itemsPerPage,
    totalItems
  );
  const currentItems = filteredExpenses.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const columns = [
    { key: "propertyName", title: "Property Name", type: "text" },
    { key: "tenantName", title: "Tenant Name", type: "text" },
    { key: "expenseType", title: "Expense Type", type: "text" },
    { key: "amount", title: "Expense Amount", type: "number" },
    { key: "date", title: "Date", type: "date" },
    { key: "actions", title: "Actions", type: "component"},
  ];

  const handleEdit = (expense: ExpenseInfo) => {
    setSelectedExpense(expense);
    
    // Find the property in your PropertiesData to get the address ID
    const allProperties = [
      ...(PropertiesData.data?.data?.COMMERCIAL || []),
      ...(PropertiesData.data?.data?.RESIDENTIAL || []),
    ];
    
    const property = allProperties.find(
      (prop: any) => prop.propertyName === expense.propertyName
    );
    
    if (property) {
      setActiveAddressId(property.id);
    } else {
      // If property not found, try to get it from the expense data if available
      const expenseItem = expenses.data?.data?.content.find((item: Expense) => 
        item.propertyName === expense.propertyName
      );
      if (expenseItem?.propertyAddress?.id) {
        setActiveAddressId(expenseItem.propertyAddress.id);
      }
    }
    
    setOpenPopup(true);
  };

  const handleDelete = () => {
    if (!activeId) return;
    deleteExpense.mutateAsync(activeId).then(() => {
      setDeletPopup(false);
    });
  };

  const handleSubmit = async (formData: Partial<ExpenseInfo>) => {
    try {
      if (addExpenseStatus) {
        // ADD EXPENSE LOGIC
        try {
          const allProperties = [
            ...(PropertiesData.data?.data?.COMMERCIAL || []),
            ...(PropertiesData.data?.data?.RESIDENTIAL || []),
          ];
          const selectedProperty = allProperties.find(
            (prop: any) => prop.id === activeAddressId
          );

          if (!selectedProperty) {
            toast.error("Please select a valid property.");
            return;
          }
          if (activeAddressId === undefined || activeAddressId === null) {
            toast.error("Property Address ID is missing. Please select a property.");
            return;
          }

          const expenseData: CreateExpenseRequest = {
            propertyName: selectedProperty.propertyName,
            tenantName: selectedProperty.tenantName || "",
            expenseType: formData.expenseType || "",
            amount: parseInt(formData.amount as unknown as string),
            date: formData.date || "",
            comments: formData.comments || "",
            propertyAddress: activeAddressId,
          };

          await addExpense.mutateAsync(expenseData).then(() => {
            setAddExpense(false);
            setOpenPopup(false);
          });
        } catch (error: any) {
          if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
          } else {
            toast.error("Something went wrong while adding expense!");
          }
        }
      } else {
        // UPDATE EXPENSE LOGIC
        try {
          // Ensure activeAddressId is set
          if (!activeAddressId) {
            toast.error("Property Address ID is missing. Please select a property.");
            return;
          }

          // Get the selected property details if we need to update property-related fields
          const allProperties = [
            ...(PropertiesData.data?.data?.COMMERCIAL || []),
            ...(PropertiesData.data?.data?.RESIDENTIAL || []),
          ];
          
          const selectedProperty = allProperties.find(
            (prop: any) => prop.id === activeAddressId
          );

          // If property name changed, we need to validate the selected property
          if (formData.propertyName !== selectedExpense.propertyName && !selectedProperty) {
            toast.error("Please select a valid property.");
            return;
          }

          const updateData: CreateExpenseRequest = {
            propertyName: formData.propertyName || selectedExpense.propertyName,
            tenantName: formData.tenantName || selectedExpense.tenantName,
            expenseType: formData.expenseType || selectedExpense.expenseType,
            amount: parseInt(formData.amount as unknown as string) || selectedExpense.amount,
            date: formData.date || selectedExpense.date,
            comments: formData.comments || selectedExpense.comments,
            propertyAddress: activeAddressId,
          };

          await updateExpense
            .mutateAsync({
              id: activeId,
              updatedExpense: updateData,
            })
            .then(() => {
              setAddExpense(false);
              setOpenPopup(false);
            });
        } catch (error: any) {
          if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
          } else {
            toast.error("Something went wrong while updating expense!");
          }
        }
      }

      setAddExpense(false);
    } catch (error) {
      console.error("Error occurred during mutation:", error);
    }
  };

  const onDateRangeChange = (dateRange: Dayjs[] | null) => {
    if (dateRange && dateRange[0] && dateRange[1]) {
      setDateFilter({
        startDate: dateRange[0].format("YYYY-MM-DD"),
        endDate: dateRange[1].format("YYYY-MM-DD"),
      });
    } else {
      // Reset to current month when cleared
      setDateFilter({
        startDate: dayjs().startOf('month').format("YYYY-MM-DD"),
        endDate: dayjs().endOf('month').format("YYYY-MM-DD"),
      });
    }
    // Reset to first page when filter changes
    setCurrentPage(0);
  };

  const handleCancel = () => {
    setOpenPopup(false);
  };

  const { RangePicker } = DatePicker;

  useEffect(() => {
    if (!PropertiesData.isLoading && PropertiesData.data) {
      // Properties data loaded
    } else if (PropertiesData.isError) {
      console.error("Error fetching properties:", PropertiesData.error);
    }
  }, [
    PropertiesData.isLoading,
    PropertiesData.data,
    PropertiesData.isError,
    PropertiesData.error,
  ]);

  return (
    <div className="flex flex-col h-full w-full">
      {/* Header - Fixed */}
      <header className="sticky top-0 bg-white shadow z-10">
        <h1 className="text-2xl text-start font-bold px-5 py-2">Expenses</h1>
        <div className="py-4 px-5 flex flex-col w-full items-center justify-between">
          <div className="flex flex-col sm:flex-row w-full items-center justify-between gap-4">
            <RangePicker
              id={"dateDuration"}
              size="large"
              className="lg:w-full xl:w-auto"
              placeholder={["start-date", "end-date"]}
              defaultValue={[dayjs().startOf('month'), dayjs().endOf('month')]}
              popupClassName="custom-range-picker-dropdown"
              onChange={(dateRange) => {
                onDateRangeChange(dateRange as Dayjs[]);
              }}
            />

            <div className="w-full sm:w-auto">
              {/* <SearchBar
                suggestionInputEnable={{
                  setActiveValue: (value: string) => {
                    setSearchQuery(value);
                  },
                  activeValue: searchQuery,
                  enable: true,
                  loading: PropertiesData.isLoading,
                  onSuggestionSelect: (index: number) => {
                    const allProperties = [
                      ...(PropertiesData.data?.data?.COMMERCIAL || []),
                      ...(PropertiesData.data?.data?.RESIDENTIAL || []),
                    ];
                    if (allProperties[index]) {
                      setPropertyId(allProperties[index]?.id);
                      setSearchQuery(allProperties[index]?.propertyName);
                    }
                  },
                  suggestions: PropertiesData.isLoading
                    ? []
                    : [
                        ...(PropertiesData.data?.data?.COMMERCIAL || []).map(
                          (item: any) => item.propertyName
                        ),
                        ...(PropertiesData.data?.data?.RESIDENTIAL || []).map(
                          (item: any) => item.propertyName
                        ),
                      ].flat() || [],
                }}
                onClear={() => {
                  setSearchQuery("");
                  setDateFilter({
                    startDate: dayjs().startOf('month').format("YYYY-MM-DD"),
                    endDate: dayjs().endOf('month').format("YYYY-MM-DD"),
                  });
                  setPropertyId(null);
                }}
                onSearch={(query) => setSearchQuery(query)}
              /> */}
              <SearchBar
  suggestionInputEnable={{
    setActiveValue: (value: string) => {
      setSearchQuery(value);
    },
    activeValue: searchQuery,
    enable: true,
    loading: PropertiesData.isLoading,
    onSuggestionSelect: (index: number) => {
      // Get all properties
      const allProperties = [
        ...(PropertiesData.data?.data?.COMMERCIAL || []),
        ...(PropertiesData.data?.data?.RESIDENTIAL || []),
      ];
      
      // Get all property names
      const allPropertyNames = allProperties.map(property => property.propertyName);
      
      // Filter property names based on current search query
      const filteredPropertyNames = allPropertyNames.filter(name =>
        name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      
      // Get the selected property name from the filtered list
      if (index >= 0 && index < filteredPropertyNames.length) {
        const selectedPropertyName = filteredPropertyNames[index];
        
        // Find the property with this exact name
        const selectedProperty = allProperties.find(
          property => property.propertyName === selectedPropertyName
        );
        
        if (selectedProperty) {
          setPropertyId(selectedProperty.id);
          setSearchQuery(selectedProperty.propertyName);
        }
      }
    },
    suggestions: PropertiesData.isLoading
      ? []
      : [
          ...(PropertiesData.data?.data?.COMMERCIAL || []).map(
            (item: any) => item.propertyName
          ),
          ...(PropertiesData.data?.data?.RESIDENTIAL || []).map(
            (item: any) => item.propertyName
          ),
        ].flat() || [],
  }}
  onClear={() => {
    setSearchQuery("");
    setDateFilter({
      startDate: dayjs().startOf('month').format("YYYY-MM-DD"),
      endDate: dayjs().endOf('month').format("YYYY-MM-DD"),
    });
    setPropertyId(null);
  }}
  onSearch={(query) => setSearchQuery(query)}
/>
            </div>
            <button
              className="bg-primary text-white flex gap-1 justify-center hover:bg-secondary rounded-lg px-4 py-2 text-sm w-full sm:w-auto"
              onClick={() => {
                setSelectedExpense(initialData);
                setAddExpense(true);
                setOpenPopup(true);
              }}
            >
              Add{" "}
              <span className="lg:hidden sm:block md:block xl:block">
                New
              </span>
            </button>
          </div>
        </div>
      </header>

      {/* Scrollable Table Content */}
      <div className="flex-1 overflow-hidden">
        <div className="h-full overflow-auto">
          <Table
            columns={columns as any}
            loading={expenses.isLoading}
            data={
              currentItems.map((item: Expense) => ({
                propertyName: item.propertyName,
                tenantName: item.tenantName || "",
                expenseType: item.expenseType,
                amount: item.amount,
                date: item.date,
                comments: item.comments || "",
                actions: (
                  <EditAndDeleteButton
                    onDelete={() => {
                      setDeletPopup(true);
                      setActiveId(String(item.id));
                    }}
                    onEdit={() => {
                      setActiveId(String(item.id));
                      setActiveAddressId(item.propertyAddress?.id);
                      handleEdit({
                        propertyName: item.propertyName,
                        tenantName: item.tenantName || "",
                        expenseType: item.expenseType,
                        amount: item.amount,
                        date: item.date,
                        comments: item.comments || "",
                        expenseId: String(item.id),
                      });
                    }}
                  />
                ),
              })) || []
            }
          />
        </div>
      </div>

      {openPopup && (
        <Popup
          closeButton={true}
          children={
            <ExpenseForm
              setActiveAddressId={setActiveAddressId}
              activeAddressId={activeAddressId} 
              isLoading={addExpense.isPending || updateExpense.isPending}
              initialData={selectedExpense}
              onSubmit={handleSubmit}
              onCancel={handleCancel}
              isOpen={openPopup}
              id={selectedExpense?.expenseId}
            />
          }
          onClose={() => setOpenPopup(false)}
        />
      )}
      {DeletPopup ? (
        <Popup
          children={
            <DeletePopup
              isLoading={deleteExpense.isPending}
              isOpen={DeletPopup}
              onClose={() => setDeletPopup(false)}
              onDelete={handleDelete}
            />
          }
          onClose={() => setDeletPopup(false)}
        />
      ) : null}

      {/* Pagination - Fixed */}
      <footer className="sticky bottom-0 bg-blue-50 shadow z-10">
        <div className="flex justify-center space-x-2 p-2">
          <Pagination
            data={currentItems}
            ExportFunction={true}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            totalItems={totalItems}
            onPageChange={setCurrentPage}
            onPageSizeChange={setItemsPerPage}
            fileName="Expenses" 
          />
        </div>
      </footer>
    </div>
  );
};

export default ExpenseCard;